module.exports = __webpack_public_path__ + "static/media/mdwa.ba50e0c5.woff2";